// extracted by mini-css-extract-plugin
export default {"badgeContainer":"InvitationUserSelectOption-module__badgeContainer--OMP1-"};